import { Page } from '@backstage/core-components';
import {
  TechDocsReaderPageContent,
  TechDocsReaderPageContentProps,
  TechDocsReaderPageHeader,
  TechDocsReaderPageSubheader,
  TechDocsSearch,
} from '@backstage/plugin-techdocs';
import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import Box from '@mui/material/Box';
import { TechDocsFeedbackAddonContent } from './TechDocsFeedbackAddon';

export const TechDocsReaderPageContentWithFeedback = (
  props: TechDocsReaderPageContentProps,
) => {
  const { withSearch = true, searchResultUrlMapper } = props;
  const { entityRef, entityMetadata } = useTechDocsReaderPage();

  return (
    <>
      {withSearch && (
        <Box
          sx={{
            gridArea: 'pageSubheader',
            px: 3,
            pt: 3,
            pb: 2,
            '@media print': {
              display: 'none',
            },
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexWrap: { xs: 'wrap', sm: 'nowrap' },
              gap: 2,
              minHeight: { xs: 104, sm: 56 },
              position: 'relative',
              zIndex: 1,
              width: '100%',
              '@media (min-width: 76.1875em)': {
                columnGap: '1.2rem',
                display: 'grid',
                gridTemplateColumns: '16rem calc(100% - 34.4rem) 16rem',
                rowGap: 0,
              },
            }}
          >
            <Box
              sx={{
                flex: '1 1 20rem',
                minWidth: 0,
                '& [class*="MuiFormControl-marginNormal"]': {
                  my: 1.5,
                },
                '@media (min-width: 76.1875em)': {
                  gridColumn: 2,
                },
              }}
            >
              <TechDocsSearch
                entityId={entityRef}
                entityTitle={entityMetadata.value?.metadata?.title}
                searchResultUrlMapper={searchResultUrlMapper}
              />
            </Box>
            <Box
              sx={{
                flex: '0 0 auto',
                '@media (min-width: 76.1875em)': {
                  gridColumn: 3,
                  justifySelf: 'start',
                },
              }}
            >
              <TechDocsFeedbackAddonContent useShadowRootStyles={false} />
            </Box>
          </Box>
        </Box>
      )}
      {/* Search is rendered above so feedback can align beside it; disable the built-in search to avoid a duplicate. */}
      <TechDocsReaderPageContent {...props} withSearch={false} />
    </>
  );
};

export const TechDocsReaderLayoutWithFeedback = () => (
  <Page themeId="documentation">
    <TechDocsReaderPageHeader />
    <TechDocsReaderPageSubheader />
    <TechDocsReaderPageContentWithFeedback />
  </Page>
);
